@if (isInBrowserMode()) {
    <section
        data-testid="gallery-carousel"
        class="gallery-carousel"
        [attr.aria-roledescription]="'carousel'"
        [attr.aria-label]="'Highlighted images'"
        [attr.aria-live]="'polite'">
        <div class="swiper-navigation">
            <button
                class="pagination-previous-slide"
                (click)="previousSlide()"
                [attr.aria-controls]="'carousel-' + paginationId">
                <h-svg-icon [name]="'arrow-left'"></h-svg-icon>
                <span hSrOnlyNoSnippet i18n="@@hermes.accessibility.previous-image">Previous image</span>
            </button>
            <div class="paragraph-medium" [class]="paginationClass"></div>
            <button
                class="pagination-next-slide"
                (click)="nextSlide()"
                [attr.aria-controls]="'carousel-' + paginationId">
                <h-svg-icon [name]="'arrow-right'"></h-svg-icon>
                <span hSrOnlyNoSnippet i18n="@@hermes.accessibility.next-image">Next image</span>
            </button>
        </div>
        <swiper #swiper [config]="sliderConfig" (slideChange)="changeSlide()" [attr.id]="'carousel-' + paginationId">
            @for (mediaSlide of galleryCarousel.mediaSlides; track mediaSlide; let index = $index) {
                <ng-template swiperSlide>
                    @if (mediaSlide.media) {
                        <div class="swiper-slide-container" [attr.role]="'group'" [attr.aria-roledescription]="'slide'">
                            @if (isMediaPreloaded(index)) {
                                <h-media-cta
                                    [attr.aria-hidden]="index !== activeIndex ? 'true' : 'false'"
                                    [attr.aria-live]="index === activeIndex ? 'polite' : undefined"
                                    (mediaRedirectionEvent)="onMediaRedirectionEvent($event, mediaSlide.media.caption)"
                                    [attr.aria-atomic]="index === activeIndex"
                                    [class.prevent-click]="index !== activeIndex"
                                    [media]="mediaSlide.media"
                                    [isPlaying]="activeIndex === index"
                                    [attr.inert]="index !== activeIndex || null"
                                    [mediaOptions]="mediaOptions"
                                    [preloadPoster]="false"
                                    [token]="mediaSlide.token"></h-media-cta>
                            }
                        </div>
                    }
                </ng-template>
            }
        </swiper>
    </section>
}
